import React from 'react';
import { connect } from 'react-redux';
import { useIntl } from 'react-intl';
import { fetchWorkspaceForm } from '@/workspaces/actions';
import { readStates, states } from '@/constants/lifecycle';
import { workspaceForms, workspaceReferenceFieldCode } from '@/workspaces/constants';
import findResult from '@/utils/resultsHelper';
import { workspaceFormSections } from '@/workspaces/state/state';
import fetch from '@/workspaces/hooks/fetch';
import FormListItems from '@/forms/components/FormListItems';
import formFieldType, { formFieldText, formDisplayFields } from '@/forms/helper';
import FormLinkDescription from '@/forms/components/FormLinkDescription';
import { resolveRequestWorkflow } from '../../state/state';
import requestFieldComponents from '../../forms/helper';
import RequestObjectDescription from '../../forms/components/RequestObjectDescription';

const fieldComponentsWithNested = {
  ...requestFieldComponents,
  link: { component: FormLinkDescription, hasLabel: true },
  object: { component: RequestObjectDescription, hasLabel: true },
};

const RequestWorkspaceFieldListItems = ({
  category,
  code,
  fields,
  fetchData,
  readStatus,
  request,
}) => {
  const intl = useIntl();
  fetch.useFetchWorkspaceForm(fetchData, 'open', workspaceForms.REQUEST, readStatus, intl);
  return (
    <FormListItems
      category={category}
      code={code}
      component={(f) => fieldComponentsWithNested[formFieldType(f)]}
      fields={fields}
      saveErrors={[]}
      saveStatus={states.NONE}
      section="workspace"
      text={(f) => formFieldText(request, f, 'fields.')}
    />
  );
};

const mapStateToProps = ({
  requests: { requests },
  workflows: { workflows },
  workspaces: { forms },
}, ownProps) => {
  const { request } = resolveRequestWorkflow(requests, workflows, ownProps);
  const item = findResult(forms, 'open', workspaceForms.REQUEST) || { ...workspaceFormSections(), ...readStates };

  return (
    {
      fields: formDisplayFields(item.sections.workspace.fields, [workspaceReferenceFieldCode]),
      readStatus: item.readStatus,
      request,
    }
  );
};

const mapDispatchToProps = {
  fetchData: fetchWorkspaceForm,
};

export default connect(mapStateToProps, mapDispatchToProps)(RequestWorkspaceFieldListItems);
